import React, { useEffect, useState } from "react";
import { LinearProgress } from "@material-ui/core";
import { Modal } from "../../../../app/components";
import { nanoid } from "nanoid";
import styled from "styled-components";
import { useScheduleEvents } from "../../../../app/contexts/schedule.events.context";
import { ViewScheduleEventForm } from "./view.schedule.events.form";
import OutlinedButton from "../../../../app/components/buttons/outlined";

const ViewScheduleOfEventModal = ({ soe, ...props }) => {
  const [reRenderForm, setReRenderForm] = useState(nanoid());
  const { fetchASingleSOE } = useScheduleEvents();

  const [SOEEventParameters, setSOEEventParameters] = useState({
    scheduleOfEventsName: soe?.scheduleOfEventsName || "",
    scheduleOfEventsDescr: soe?.scheduleOfEventsDescr || "",
    scheduleOfEventsStatus: soe?.scheduleOfEventsStatus || "",
    studyPlanId: soe?.studyPlanId || "",
    visitIntervalType: soe?.visitIntervalType || "",
    visitWindowIntervalType: soe?.visitWindowIntervalType || "",
    CDAReviewPctTime: soe?.CDAReviewPctTime || "",
    assessorName: soe?.assessorName || "",
    AddlTimeOnSitePct: soe?.AddlTimeOnSitePct || "",
    EstActivatedNonEnrollingSitesPct: soe?.EstActivatedNonEnrollingSitesPct || "",
    ReqAdminIMVNonEnrollingSites: soe?.ReqAdminIMVNonEnrollingSites || "",
    SubjectReportingAvgFrequency: soe?.SubjectReportingAvgFrequency || "",
    SubjectReportingHoursToGenerate: soe?.SubjectReportingHoursToGenerate || "",
    StudyReportingAvgFrequency: soe?.StudyReportingAvgFrequency || "",
    StudyReportingHoursToGenerate: soe?.StudyReportingHoursToGenerate || "",
    StudyAdhocReview: soe?.StudyAdhocReview || "",
    protocolVersion: soe?.protocolVersion || "",
    protocolDate: soe?.protocolDate || "",
    currency: soe?.currency || "",
  });

  const [isProtocolVersionNA, setIsProtocolVersionNA] = useState(false);
  const [isProtocolDateNA, setIsProtocolDateNA] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Extract scheduleOfEventsId to avoid complex dependency
  const scheduleOfEventsId = soe?.scheduleOfEventsId;

  // Effect to fetch data
  useEffect(() => {
    let isMounted = true;
    let timeoutId = null;
    
    if (scheduleOfEventsId && props.open) {
      (async () => {
        setIsLoading(true);
        try {
          const res = await fetchASingleSOE(scheduleOfEventsId);
          if (res.data && res.data.length && isMounted) {
            const data = res.data[0];
            setSOEEventParameters(data);
            setIsProtocolVersionNA(!data.protocolVersion);
            setIsProtocolDateNA(!data.protocolDate);
            timeoutId = setTimeout(() => {
              if (isMounted) {
                setReRenderForm(nanoid());
                setIsLoading(false);
              }
            }, 400);
          } else if (isMounted) {
            setIsLoading(false);
          }
        } catch (error) {
          console.error('Error fetching SOE data:', error);
          if (isMounted) {
            setIsLoading(false);
          }
        }
      })();
    }
    
    // Cleanup function
    return () => {
      isMounted = false;
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
    // Intentionally omitting fetchASingleSOE to prevent infinite loops
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheduleOfEventsId, props.open]);

  return (
    <Modal
      size={"80%"}
      maxWidth={"1200px"}
      {...props}
      aria-labelledby="View Schedule of Events"
      aria-describedby="View schedule of events details"
      title="View Schedule of Events"
    >
      {isLoading && <LinearProgress />}
      {!isLoading && (
        <Container key={reRenderForm}>
          <div style={{ display: "flex", gap: "1rem" }}>
            <ViewScheduleEventForm
              SOEEventParameters={SOEEventParameters}
              isProtocolVersionNA={isProtocolVersionNA}
              isProtocolDateNA={isProtocolDateNA}
            />
          </div>
          <ButtonContainer>
            <OutlinedButton onClick={props.onClose}>Close</OutlinedButton>
          </ButtonContainer>
        </Container>
      )}
    </Modal>
  );
};

export default ViewScheduleOfEventModal;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 2em;
  padding-inline: 1em;
  max-height: 75vh;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1em;
  background-color: white;
  with: 100%;
  position: sticky;
  bottom: -13px;
  z-index: 10;
  padding: 1rem 0rem;
`;
